<h1>{{ 'OPS' | translate }}!</h1>
<p>{{ 'WE_DID_NOT_FIND' | translate }} :-/</p>
